import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import type { OrganizationUsersMeResponse } from 'apis/organization_users/me';
import type { OrganizationsResponse } from 'apis/organizations/organizations_response_type';
import type { UsersMeResponse } from 'apis/users/me';

export const currentUserAtom = atomWithReset<UsersMeResponse>({
  id: 0,
  email: '',
});

export const currentOrganizationUserAtom =
  atomWithReset<OrganizationUsersMeResponse>({
    id: 0,
    status: 'inactive',
    name: null,
    userId: null,
    speciality: null,
    jobCategory: null,
    dataAnalysisExperience: null,
    iconImageUrl: null,
    identicon: '',
    logoUrl: null,
    permittedServices: {
      quest: false,
      competition: false,
      dxCopilotPlanner: false,
      dxCopilotAnalytics: false,
    },
  });

export const currentOrganizationAtom = atomWithReset<OrganizationsResponse>({
  id: 0,
  name: '',
  companyName: null,
  ssoOnly: false,
  userInquiryFormUrl: null,
});

export const activeNavLinkAtom = atom<string>('');
